import { render, staticRenderFns } from "./BusinessOmniplayEventsSimpleCore.vue?vue&type=template&id=2d510a86"
import script from "./BusinessOmniplayEventsSimpleCore.vue?vue&type=script&lang=js"
export * from "./BusinessOmniplayEventsSimpleCore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports